'use strict';

import { WebSecureDemoController, Config } from './web-secure-demo-controller';

/**
 * WebSecureDisplayDemo - Entry point of the demo
 * This file orchestrates initialization and coordination between the controller and UI
 */

// Global instance of the controller
let demoController: WebSecureDemoController;

/**
 * Application initialization on load
 */
window.onload = () => {
    fetch('config/config.json')
        .then((response) => response.json())
        .then((data: Config) => {
            // Create the controller instance with the configuration
            demoController = new WebSecureDemoController(data);

            // Update the title with the issuer ID
            const titleElement = document.getElementById('title');
            if (titleElement) {
                titleElement.innerText = demoController.getXIssuerId();
            }

            // Attach event listeners
            setupEventListeners();

            // Initialize UI options
            demoController.handleTypeChange();
        })
        .catch((error) => {
            console.error('Failed to load configuration:', error);
        });
};

/**
 * Configure all application event listeners
 */
function setupEventListeners(): void {
    const secureTypeElement = document.getElementById('secureType');
    if (secureTypeElement) {
        secureTypeElement.addEventListener('change', () => {
            demoController.handleTypeChange();
        });
    }

    const submitBtn = document.getElementById('submit-btn');
    if (submitBtn) {
        submitBtn.addEventListener('click', () => {
            demoController.requestWebSecure();
        });
    }

    const errorBtn = document.getElementById('error-btn');
    if (errorBtn) {
        errorBtn.addEventListener('click', () => {
            demoController.requestWebSecureWithError();
        });
    }
}
